







import Vue from "vue";

export default Vue.extend({
  name: "App",
  metaInfo: {
    title: "Türkiye'nin ilk turizm temalı uzaktan eğitim portalı",
    titleTemplate: "%s - UTE Akademi",
    meta: [
      {
        name: "description",
        content:
          "Turizm kariyerinizin başlangıç noktasına hoş geldiniz! Turizm sektöründe başarılı bir kariyere sahip olmak için gerekli tüm yetkinlikler bir tık uzağınızda."
      }
    ]
  }
});
